"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseConcurError = void 0;
/**
 * @deprecated
 * remota-exporter-internal でしか使わない
 */
function parseConcurError(plain) {
    var _a;
    var p = plain.replace(/^There\s+were\s+\d+\s+field\s+errors:\s*/, "");
    var result = [];
    var reg = /\s*(\w+)\s*=\s*([^;]*)\s*(;|$)/u;
    var work = {};
    while (p.match(reg)) {
        var _b = __read(p.match(reg), 3), all = _b[0], k = _b[1], v = _b[2];
        work = __assign(__assign({}, work), (_a = {}, _a[k.toLowerCase()] = v, _a));
        p = p.substr(all.length);
        if (isConcurExportErrorFilled(work)) {
            result.push(work);
            work = {};
        }
    }
    return result;
}
exports.parseConcurError = parseConcurError;
function isConcurExportErrorFilled(work) {
    var keys = ["level", "field", "value", "code", "message"];
    return keys.every(function (key) { return work[key] !== undefined; });
}
